export default class PDFFormat {
  id: string
  name: string

  constructor(json) {
    this.id = json.id
    this.name = json.name
  }
}
